import { ShiftService, AccountsService, EmployeesService, DeclarationService } from "../../services/index";

export const scheduleState: aboTheme.IState = {

  parent: 'app',
  name: "schedule",
  url: "/schedule",
  component: 'scheduleComponent',
  redirectTo: 'schedule.calendar',
  data: {
    permissions: {
        only: ['EMPLOYEE']
    }
  }
};

export const scheduleCalendarState: aboTheme.IState = {

  name: "schedule.calendar",
  url: "/calendar",
  views: {
    "main": 'scheduleCalendarComponent'
  },
  resolve: {
    statuses : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('ShiftStatus'); }
  }
};

export const scheduleListState: aboTheme.IState = {
  name: "schedule.list",
  url: "/list?start",
  params: {
    shiftId: null,
    start: null
  },
  views: {
    "main": 'scheduleListComponent'
  },
  resolve: {
  },
  data: {
    contentClasses: 'no-padding'
  }
};

export const scheduleListItemState = {
  name: "schedule.list.item",
  url: "/item/:id",
  resolve: {
     
  },
  views: {
      "shiflistitem@schedule.list": 'scheduleItemComponent'
  },
};

export const scheduleListItemDeclarationState = {
  name: "schedule.declarations",
  url: "/declaration?openShiftId",
  params: {
    openShiftId: null,
  },
  resolve: {
     
  },
  views: {
      "main": 'scheduleDeclarationComponent'
  },
};

export const scheduleDeclarationState: aboTheme.IState = {

    name: "schedule.declarations.declaration",
    url: "/declaration/:declarationId?employeeId&shiftId&type&shiftStartDate&shiftEndDate",
    params: {
        employeeId: null,
        shiftId: null,
        type: null,
        shiftStartDate: null,
        shiftEndDate: null,
    },
    modal: [],
    resolve: {
        wageCodes: (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('HourCodes'); },
        declaration: (DeclarationService: DeclarationService, $stateParams: ng.ui.IStateParamsService) => {
            "ngInject";
            if ($stateParams['declarationId']) {
                return DeclarationService.get($stateParams['declarationId']);
            }
        },
        refresh: () => { return true; }
    },
    component: 'declarationComponent'
};

export const scheduleAvailabilityState: aboTheme.IState = {

  name: "schedule.calendar.availability",
  url: "/availability/:availabilityId",
  params: {
    "availabilityId": null
  },
  modal: [],
  resolve: {
    statuses: (MasterdataService: aboMasterdata.IService) => {
        'ngInject';
        return MasterdataService.getItems('AvalabilityStatus');
    }
  },
  component: 'availabilityItemComponent'

};

export const scheduleShiftItemState = {

  name: "schedule.list.item.edit",
  url: "/edit",
  params: {
    "status": null
  },
  modal: true,
  size: "lg",
  resolve: {
    shift: (ShiftService: ShiftService, $stateParams: ng.ui.IStateParamsService) => {
      "ngInject";
      if ($stateParams['id']) {
        return ShiftService.get($stateParams['id']);
      }
    },
    functions : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('Functions'); },
    accounts : (AccountsService: AccountsService) => { "ngInject"; return AccountsService.all(); },
    employees : (EmployeesService: EmployeesService) => { "ngInject"; return EmployeesService.getEmployeesByStatus(); },
    statuses : (MasterdataService: aboMasterdata.IService) => { "ngInject"; return MasterdataService.getItems('ShiftStatus'); },
    refresh: () => { return true; }
  },
  component: 'shiftItemComponent'
};

export const scheduleSubscriptionState: aboTheme.IState = {

  name: "schedule.calendar.subscription",
  url: "/subscription/:employeeId/:subscriptionId",
  params: {
    "subscriptionId": null
  },
  modal: [],
  resolve: {
  },
  component: 'subscriptionItemComponent'

};


// WEBPACK FOOTER //
// ./src/app/modules/schedule/schedule.states.ts